import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home'
import Zap from '../views/Zap'
import P404 from '../views/NotFound'
import Blank from '../views/Blank'

import Links from '../../../pages/Links'
import NotFound from '../../../pages/NotFound'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeGo',
    component: Home
  },
  {
    path: '/m/:hash',
    name: 'Zap',
    component: Zap
  },
  {
    path: '/404',
    name: 'P404',
    component: P404
  },
  {
    path: '/:id',
    name: 'Home',
    component: Blank
  },
  {
    path: '/:id/home',
    redirect: '/:id'
  },
  {
    path: '/:id/nolocal',
    name: 'NoLocal',
    component: Blank
  },
  {
    path: '/:id/pedidos',
    name: 'Pedidos',
    component: Blank
  },
  {
    path: '/:id/info',
    name: 'Info',
    component: Blank
  },
  {
    path: '/:id/promocoes',
    name: 'Promocoes',
    component: Blank
  },
  {
    path: '/:id/perfil',
    name: 'Perfil',
    component: Blank
  },
  {
    path: '/:id/categorias',
    name: 'Categorias',
    component: Blank
  },
  {
    path: '/:id/links',
    name: 'Links',
    component: Links
  },
  {
    path: '/*',
    name: 'NotFound',
    component: NotFound
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
